module.exports = vendors_ru_640f978d39b77ac1c554;